import { getCookie } from '../functions';

class OpenYoutubeModal {
    constructor() {
        $('.open-youtube-popup').on('click', async (e) => {
            e.preventDefault();
            let hasConsent = false;
            const consentCookie = await getCookie('occ');
            if (consentCookie) {
                const cookieConsent = consentCookie.split(',');
                hasConsent = cookieConsent.includes('allcookies') || cookieConsent.includes('Media') || cookieConsent.includes('Video');
            }

            if (hasConsent) {
                $.magnificPopup.open({
                    items: {
                        src: $(e.currentTarget).attr('href')
                    },
                    type: 'iframe',
                    closeOnContentClick: true,
                    mainClass: 'mfp-img-mobile',
                    iframe: {
                        markup: '<div class="mfp-iframe-scaler">' +
                            '<div class="mfp-close"></div>' +
                            '<iframe class="mfp-iframe" frameborder="0" allow="autoplay" referrerpolicy="strict-origin-when-cross-origin"></iframe>' +
                            '</div>',
                        patterns: {
                            youtube: {
                                index: 'https://www.youtube.com/',
                                id: function (url) {
                                    var m = url.match(/[\\?&]v=([^\\?&]+)/);
                                    return m && m[1] ? m[1] : null;
                                },
                                src: 'https://www.youtube-nocookie.com/embed/%id%?autoplay=1&iframe=true'
                            }
                        }
                    }
                });
            } else {
                $.magnificPopup.open({
                    showCloseBtn: true,
                    closeBtnInside: true,
                    items: {
                        src:`<div class="modal--content rte">
                                <button class="mfp-close">×</button>
                                <p>${$(e.currentTarget).data('notification')}</p>
                                <p><a href="${$(e.currentTarget).attr('href')}" target="_blank">${$(e.currentTarget).data('notificationlink')}</a></p>
                            </div>`

                    },
                    type: 'inline'
                });
            }
        });
    }
}

export default OpenYoutubeModal;